// Messages for operator/CustomDashboards (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.custom_dashboards.head': 'Custom dashboards — Operator',
  'operator.custom_dashboards.title': 'Custom dashboards',
  'operator.custom_dashboards.desc':
    'Compose and save your own dashboards from the widget catalog.',
  'operator.custom_dashboards.compose': 'New dashboard',
  'operator.custom_dashboards.name_label': 'Name',
  'operator.custom_dashboards.name_placeholder': 'e.g. Exceptions watch',
  'operator.custom_dashboards.save': 'Save dashboard',
  'operator.custom_dashboards.delete': 'Delete',
  'operator.custom_dashboards.empty': 'No saved dashboards yet — compose one above.',
  'operator.custom_dashboards.nav': 'Custom dashboards',
  'operator.custom_dashboards.widget.kpis': 'KPIs',
  'operator.custom_dashboards.widget.status_mix': 'Status mix',
  'operator.custom_dashboards.widget.volume': 'Volume by mode',
  'operator.custom_dashboards.widget.needs_attention': 'Needs attention',
  'operator.custom_dashboards.widget.top_lanes': 'Top lanes',
}

export const zhTW = {
  'operator.custom_dashboards.head': '自訂儀表板 — 操作員',
  'operator.custom_dashboards.title': '自訂儀表板',
  'operator.custom_dashboards.desc': '從小工具目錄組合並儲存您專屬的儀表板。',
  'operator.custom_dashboards.compose': '新增儀表板',
  'operator.custom_dashboards.name_label': '名稱',
  'operator.custom_dashboards.name_placeholder': '例如：異常監控',
  'operator.custom_dashboards.save': '儲存儀表板',
  'operator.custom_dashboards.delete': '刪除',
  'operator.custom_dashboards.empty': '尚無已儲存的儀表板 — 請於上方組合一個。',
  'operator.custom_dashboards.nav': '自訂儀表板',
  'operator.custom_dashboards.widget.kpis': '關鍵指標',
  'operator.custom_dashboards.widget.status_mix': '狀態分布',
  'operator.custom_dashboards.widget.volume': '各運輸方式量',
  'operator.custom_dashboards.widget.needs_attention': '需要關注',
  'operator.custom_dashboards.widget.top_lanes': '主要航線',
}
